<template>
  <div id="contents">
    <div id="exModify" class="container">
      <h3 class="stitle mb10">예약결제</h3>

      <h4 class="stitle2 mb10 tleft">예약확인</h4>
      <div class="tb_wrap mb30 res_tbl_grid_wrap">
        <table class="tb_basic">
          <caption>예약확인</caption>
          <tbody>
            <tr>
              <th class="tbg cw120">예약번호</th>
              <td class="tleft">{{ bundleRvNo }}</td>
              <th class="tbg cw120">예약상태</th>
              <td class="tleft">{{ reserveInfo.rvSitu }}</td>
            </tr>
            <tr>
              <th class="tbg cw120">예약일</th>
              <td class="tleft">{{ reserveInfo.rvDtm }}</td>
              <th class="tbg cw120">예약자명</th>
              <td class="tleft">{{ reserveInfo.userName }}</td>
            </tr>
            <tr>
              <th class="tbg cw120">휴대폰</th>
              <td class="tleft">{{ reserveInfo.userMobileNum }}</td>
              <th class="tbg cw120">이메일</th>
              <td class="tleft">{{ reserveInfo.userEmail }}</td>
            </tr>
            <tr v-if="reserveInfo.hpOrgInfoId > 0">
              <th class="tbg cw120">단체명</th>
              <td class="tleft">{{ reserveInfo.orgName }}</td>
              <th class="tbg cw120">학년</th>
              <td class="tleft">{{ reserveInfo.gradeNm }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <ul class="basketList">
        <li v-for="rv in detailList" :key="rv.pdRvNo">
          <dl>
            <dt class="stitle2">{{ rv.pdNm }}</dt>
            <dd class="colorBox">
              <ul class="listBox">
                <li>
                  <strong>날짜</strong>
                  <span>{{ rv.expVisitRvdt }}</span>
                </li>
                <li>
                  <strong>회차</strong>
                  <span>{{ rv.scheSeqNo }}회차({{ rv.scheTm }})</span>
                </li>
                <li class="wdful">
                  <strong>인원</strong>
                  <span>
                    <i>체험자 {{ rv.experPcnt }}명</i>
                    <i v-if="rv.leaderPcnt > 0">인솔자 {{ rv.leaderPcnt }}명</i>
                  </span>
                </li>
                <!-- <li v-if="groupPersDiv === '01' && booking.multiDiscountYn">
                  <span class="checkbox">
                    <input type="checkbox" :id="'md_' + i" name="multiDiscountYn" v-model="booking.multiDiscountYn" true-value="Y" false-value="N" />
                    <label :for="'md_' + i">각 회차에 동일 체험자가 참여합니다</label>
                  </span>
                </li> -->
              </ul>
              <div class="product_price">
                <span v-if="rv.dcAmt > 0">{{ _wonFormat(rv.rvAmt + rv.dcAmt, '무료') }}</span>
                <br />
                <strong>{{ _wonFormat(rv.rvAmt, '무료') }}</strong>
              </div>
            </dd>
          </dl>
        </li>
      </ul>

      <div class="totalPriceBox mb50">
        <ul class="div3">
          <li>
            <strong>체험금액</strong>
            <span>
              <i class="fs_big tcolor1">{{ _priceFormat(totOriginPrice) }}</i>
              원
            </span>
          </li>
          <li class="price_icon1">
            <strong>할인금액</strong>
            <span>
              <i class="fs_big">{{ _priceFormat(totDcPrice) }}</i>
              원
            </span>
          </li>
          <!-- <li class="price_icon2">
            <strong>취소수수료</strong>
            <span>
              <i class="fs_big">0</i>
              원
            </span>
          </li> -->
          <li class="price_icon3">
            <strong>총결제금액</strong>
            <span>
              <i class="fs_big">{{ _priceFormat(totSalePrice) }}</i>
              원
            </span>
          </li>
        </ul>
      </div>

      <dl class="payWay mb50">
        <dt class="stitle1 tleft mb10">결제수단</dt>
        <dd>
          <ul class="radiobox">
            <li>
              <input type="radio" name="payWaySel" id="pwCard" value="02" v-model="paymentType.payMethod" />
              <label for="pwCard"><span>카드 결제</span></label>
            </li>
            <!-- 간편결제 오픈시 제외 -->
            <li v-if="false">
              <input type="radio" name="payWaySel" id="pwEasy" value="간편결제" v-model="paymentType.payMethod" />
              <label for="pwEasy"><span>간편 결제</span></label>
              <div class="pwEasy_list mt10">
                <a class="sel_toss" :class="{ selected: checkEasyPaySelected('TOSSPAY') }" @click="() => onEasyPayClick('TOSSPAY')">
                  <span>토스페이</span>
                </a>
                <a class="sel_naver" :class="{ selected: checkEasyPaySelected('NAVERPAY') }" @click="() => onEasyPayClick('NAVERPAY')">
                  <span>네이버페이</span>
                </a>
                <a class="sel_kakao" :class="{ selected: checkEasyPaySelected('KAKAOPAY') }" @click="() => onEasyPayClick('KAKAOPAY')">
                  <span>카카오페이</span>
                </a>
              </div>
              <div class="pwEasy_list mt10">
                <a class="" :class="{ selected: checkEasyPaySelected('SAMSUNGPAY') }" @click="() => onEasyPayClick('SAMSUNGPAY')">
                  <span>삼성페이</span>
                </a>
                <a class="" :class="{ selected: checkEasyPaySelected('LPAY') }" @click="() => onEasyPayClick('LPAY')">
                  <span>엘페이</span>
                </a>
                <a class="" :class="{ selected: checkEasyPaySelected('PAYCO') }" @click="() => onEasyPayClick('PAYCO')">
                  <span>페이코</span>
                </a>
              </div>
            </li>
            <li>
              <input type="radio" name="payWaySel" id="pwbankbook" value="03" v-model="paymentType.payMethod" />
              <label for="pwbankbook"><span>계좌 이체</span></label>
            </li>
          </ul>
        </dd>
      </dl>
      <div class="agree_wrap mb10">
        <div class="agree_cont">
          <ReserveInfoText />
        </div>
      </div>
      <p class="linebox checkbox mb50">
        <input type="checkbox" name="agree" id="agree01" v-model="confirmCheck" />
        <label for="agree01">
          예약안내 및 유의사항 동의
          <strong class="tcolor2">(필수)</strong>
        </label>
      </p>
      <div class="btn_area">
        <router-link class="btn btn_bg gray" :to="`/${currentRouteType}/reservations`">예약목록</router-link>
        <a class="btn btn_bg color" @click="onPaymentClick">결제하기</a>
      </div>
    </div>
  </div>
</template>

<script>
import { getReservation, getLgupayInfo } from '@/api/api_reserve';
import lguPaymentLaunch from '@/utils/lguUtil';
import ReserveInfoText from '@/components/popup/ReserveInfoText';

export default {
  components: {
    ReserveInfoText,
  },
  data() {
    return {
      message: '',
      bundleRvNo: '',
      targetPdRvNo: '',
      reserveInfo: {},
      detailList: [],
      payInfo: {},
      tossPayments: null,
      paymentType: {
        payMethod: '02',
        easyPay: 'TOSSPAY',
      },
      confirmCheck: false,
    };
  },
  computed: {
    totOriginPrice() {
      return this.detailList.reduce((a, e) => a + e.rvAmt + e.dcAmt, 0);
    },
    totDcPrice() {
      return this.detailList.reduce((a, e) => a + e.dcAmt, 0);
    },
    totSalePrice() {
      return this.detailList.reduce((a, e) => a + e.rvAmt, 0);
    },
  },
  methods: {
    async initialLoad() {
      await this.$loadScript('https://xpayvvip.tosspayments.com/xpay/js/xpay_crossplatform.js'); //service
    },
    async normalPayment() {
      const paymentInfo = {
        payMethod: this.paymentType.payMethod,
        easyPay: '',
      };
      if (paymentInfo.payMethod === '간편결제') {
        paymentInfo.payMethod = '02';
        paymentInfo.easyPay = this.paymentType.easyPay;
      }

      let productInfo = this.detailList[0].pdNm;

      if (this.detailList.length > 1) {
        productInfo = productInfo + ' 외 ' + this.detailList.length - 1 + '건';
      }

      try {
        const data = await getLgupayInfo({
          ...paymentInfo,
          bundleRvNo: this.bundleRvNo,
          bookingList: [],
          productInfo: productInfo,
          groupPersDiv: this.groupPersDiv,
          completeUrl: '/' + this.currentRouteType + '/reserve/paymentCmpl/',
        });
        if (data.success) {
          if (data.response.amount > 0) {
            const payReq = data.response.payReq;

            lguPaymentLaunch(payReq, this.paymentSuccess);
          } else {
            this.saveOrder();
          }
        }
      } catch (e) {
        alert('오류가 발생하였습니다.');
      }
    },
    paymentSuccess(bundleRvNo) {
      this.$router.push('/' + this.currentRouteType + '/paymentCmpl/' + bundleRvNo);
    },
    async onPaymentClick() {
      if (!this.confirmCheck) {
        alert('예약안내 및 유의사항 동의를 해주세요');
        return false;
      }

      this.normalPayment();
    },
  },
  created() {
    this.bundleRvNo = this.$route.params.bundleRvNo;
    this.initialLoad();
    getReservation(this.bundleRvNo)
      .then((data) => {
        if (data.success) {
          const { reserveInfo, detailList, exhpHallList, payInfo } = data.response;

          if (reserveInfo.rvProgSitu !== '01') {
            alert('잘못된 접근 입니다.');
            this.$router.go(-1);
          }

          this.reserveInfo = reserveInfo;
          this.detailList = detailList;
          this.exhpHallList = exhpHallList;
          this.payInfo = payInfo || {};
        }
      })
      .catch((e) => {
        alert('오류가 발생하였습니다.');
      });
  },
  destroyed() {
    try {
      if (window.closeIframe) {
        closeIframe();
      }
    } catch (e) {
      //iframe 닫기 관련 에러,
    }
  },
};
</script>

<style lang="scss" scoped>
.changed {
  color: #bd0000;
}
.tlist1 {
  & span {
    padding-left: 5px;
  }
}
.basketList {
  & > li {
    & > dl {
      & > dd {
        border-top: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
        display: flex;
        justify-content: space-between;

        & .product_price {
          text-align: center;
          & span {
            text-decoration: line-through;
          }
          & strong {
            font-size: 22px;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .basketList {
    & > li {
      & > dl {
        & > dd {
          & .product_price {
            & strong {
              font-size: 18px;
            }
          }
        }
      }
    }
  }
}
</style>
